<template>
  <div @mouseenter="cycling(false)" @mouseleave="cycling(true)">
    <v-carousel :cycle="cycle" hide-delimiters
      :show-arrows-on-hover="slides.length > 1 ? true : false"
      :show-arrows="slides.length > 1 ? true : false"
      :light="!$vuetify.theme.dark" :height="425">
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <!-- npgVsXGChart -->
        <v-card
          min-height="350"
          class="card-chart"
          elevation="0" outlined
          v-if="slide === 'npgVsXGChart' && npgVsXGChart.data.labels.length > 0
          && npgVsXGChart.data.datasets[0].data.length > 0
          && npgVsXGChart.data.datasets[1].data.length > 0"
          :dark="$vuetify.theme.dark"
        >
          <template>
            <v-card-title class="py-1 white--text d-flex align-center justify-space-between" style="flex-wrap: nowrap;" :class="$vuetify.theme.dark ? 'black' : 'primary'" >
              <div class="d-flex align-center" style="flex: 1 1 auto; min-width: 0;">
                <v-icon color="white" medium class="mr-2">stacked_bar_chart</v-icon>
                <span class="white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis">{{ npgVsXGChart.title }}</span>
              </div>
              <v-menu offset-y style="flex-shrink: 0;">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="white--text"
                  >
                    <v-icon color="white">more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="saveAs('png', 'npgVsXGChart', npgVsXGChart.title)">
                    <v-list-item-title>PNG</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="saveAs('svg', 'npgVsXGChart', npgVsXGChart.title)">
                    <v-list-item-title>SVG</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-title>
            <div class="d-flex justify-space-between align-center px-4" style="padding-top: 0px !important; padding-bottom: 0px !important;">
              <div class="d-flex align-center">
                <img
                  :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${teamId ? teamId : currentUser.team.teamId}.png`"
                  width="18"
                  class="mr-1"
                  v-if="currentUser.team || teamId"
                />
                <span class="subheader-font body-2">
                  {{teamName ? teamName : (currentUser.team ? currentUser.team.teamName : currentUser.clientName)}}
                </span>
              </div>
              <v-autocomplete
                v-model="lastGamesxGvsNPGChartModel"
                :items="lastGames"
                item-disabled="disabled"
                item-text="name"
                item-value="id"
                menu-props="auto"
                hide-details
                dense
                class="body-2"
                style="max-width: 200px;"
                @change="updateDataAndRenderLineChart(npgVsXGChart, teamStatsDataAllGames, lastGamesxGvsNPGChartModel, isNeededToAccumulateStats)"
              ></v-autocomplete>
            </div>
          </template>
          <LineChart
            id="npgVsXGChart"
            :datasets="npgVsXGChart.data.datasets"
            :xAxisLabels="npgVsXGChart.data.labels"
            :gamesName="npgVsXGChart.data.gamesName"
            :options="npgVsXGChart.options"
          />
          <div class="ml-3 pb-3 primary--text subheader-font">
            <v-icon color="secondary" small>alarm</v-icon>
            {{ npgVsXGChart.textFooter }}
          </div>
        </v-card>

        <!-- xGAgainstvsNPGAgainstChart -->
        <v-card
          min-height="350"
          class="card-chart"
          elevation="0" outlined
          v-if="slide === 'xGAgainstvsNPGAgainstChart' && xGAgainstvsNPGAgainstChart.data.labels.length > 0
          && xGAgainstvsNPGAgainstChart.data.datasets[0].data.length > 0
          && xGAgainstvsNPGAgainstChart.data.datasets[1].data.length > 0"
          :dark="$vuetify.theme.dark"
        >
          <template>
            <v-card-title class="py-1 white--text d-flex align-center justify-space-between" style="flex-wrap: nowrap;" :class="$vuetify.theme.dark ? 'black' : 'primary'" >
              <div class="d-flex align-center" style="flex: 1 1 auto; min-width: 0;">
                <v-icon color="white" medium class="mr-2">stacked_bar_chart</v-icon>
                <span class="white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis">{{ xGAgainstvsNPGAgainstChart.title }}</span>
              </div>
              <v-menu offset-y style="flex-shrink: 0;">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="white--text"
                  >
                    <v-icon color="white">more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="saveAs('png', 'xGAgainstvsNPGAgainstChart', xGAgainstvsNPGAgainstChart.title)">
                    <v-list-item-title>PNG</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="saveAs('svg', 'xGAgainstvsNPGAgainstChart', xGAgainstvsNPGAgainstChart.title)">
                    <v-list-item-title>SVG</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-title>
            <div class="d-flex justify-space-between align-center px-4" style="padding-top: 0px !important; padding-bottom: 0px !important;">
              <div class="d-flex align-center">
                <img
                  :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${teamId ? teamId : currentUser.team.teamId}.png`"
                  width="18"
                  class="mr-1"
                  v-if="currentUser.team || teamId"
                />
                <span class="subheader-font body-2">
                  {{teamName ? teamName : (currentUser.team ? currentUser.team.teamName : currentUser.clientName)}}
                </span>
              </div>
              <v-autocomplete
                v-model="lastGamesxGAgainstvsNPGAgainstChartModel"
                :items="lastGames"
                item-text="name"
                item-value="id"
                menu-props="auto"
                hide-details
                dense
                class="body-2"
                style="max-width: 200px;"
                @change="updateDataAndRenderLineChart(xGAgainstvsNPGAgainstChart, teamStatsDataAllGames, lastGamesxGAgainstvsNPGAgainstChartModel, isNeededToAccumulateStats)"
              ></v-autocomplete>
            </div>
          </template>
          <LineChart
            id="xGAgainstvsNPGAgainstChart"
            :datasets="xGAgainstvsNPGAgainstChart.data.datasets"
            :xAxisLabels="xGAgainstvsNPGAgainstChart.data.labels"
            :gamesName="xGAgainstvsNPGAgainstChart.data.gamesName"
            :options="xGAgainstvsNPGAgainstChart.options"
          />
          <div class="ml-3 pb-3 primary--text subheader-font">
            <v-icon color="secondary" small>alarm</v-icon>
            {{ xGAgainstvsNPGAgainstChart.textFooter }}
          </div>
        </v-card>

        <!-- xGvsxGAgainstChart -->
        <v-card class="card-chart"
        elevation="0" outlined min-height="350"
        v-if="slide === 'xGvsxGAgainstChart' && xGvsxGAgainstChart.data.labels.length > 0
          && xGvsxGAgainstChart.data.datasets[0].data.length > 0
          && xGvsxGAgainstChart.data.datasets[1].data.length > 0"
          :dark="$vuetify.theme.dark">
          <template>
            <v-card-title class="py-1 white--text d-flex align-center justify-space-between" style="flex-wrap: nowrap;" :class="$vuetify.theme.dark ? 'black' : 'primary'" >
              <div class="d-flex align-center" style="flex: 1 1 auto; min-width: 0;">
                <v-icon color="white" medium class="mr-2">stacked_bar_chart</v-icon>
                <span class="white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis">{{ xGvsxGAgainstChart.title }}</span>
              </div>
              <v-menu offset-y style="flex-shrink: 0;">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="white--text"
                  >
                    <v-icon color="white">more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="saveAs('png', 'xGvsxGAgainstChart', xGvsxGAgainstChart.title)">
                    <v-list-item-title>PNG</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="saveAs('svg', 'xGvsxGAgainstChart', xGvsxGAgainstChart.title)">
                    <v-list-item-title>SVG</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-title>
            <div class="d-flex justify-space-between align-center px-4" style="padding-top: 0px !important; padding-bottom: 0px !important;">
              <div class="d-flex align-center">
                <img
                  :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${teamId ? teamId : currentUser.team.teamId}.png`"
                  width="18"
                  class="mr-1"
                  v-if="currentUser.team || teamId"
                />
                <span class="subheader-font body-2">
                  {{teamName ? teamName : (currentUser.team ? currentUser.team.teamName : currentUser.clientName)}}
                </span>
              </div>
              <v-autocomplete
                v-model="lastGamesxGvsxGAgainstChartModel"
                :items="lastGames"
                item-text="name"
                item-value="id"
                menu-props="auto"
                hide-details
                dense
                class="body-2"
                style="max-width: 200px;"
                @change="updateDataAndRenderLineChart(xGvsxGAgainstChart, teamStatsDataAllGames, lastGamesxGvsxGAgainstChartModel, !isNeededToAccumulateStats)"
              >
              </v-autocomplete>
            </div>
          </template>
          <LineChart
            id="xGvsxGAgainstChart"
            :datasets="xGvsxGAgainstChart.data.datasets"
            :xAxisLabels="xGvsxGAgainstChart.data.labels"
            :gamesName="xGvsxGAgainstChart.data.gamesName"
            :options="xGvsxGAgainstChart.options" />
          <div class="ml-3 pb-3 primary--text subheader-font">
            <v-icon color="secondary" small>alarm</v-icon>
            {{ xGvsxGAgainstChart.textFooter }}
          </div>
        </v-card>

        <!-- pointsVsXPointsChart -->
        <v-card
          min-height="350"
          class="card-chart"
          elevation="0" outlined
          v-if="slide === 'pointsVsXPointsChart' && pointsVsXPointsChart.data.labels.length > 0
          && pointsVsXPointsChart.data.datasets[0].data.length > 0
          && pointsVsXPointsChart.data.datasets[1].data.length > 0"
          :dark="$vuetify.theme.dark"
        >
          <template>
            <v-card-title class="py-1 white--text d-flex align-center justify-space-between" style="flex-wrap: nowrap;" :class="$vuetify.theme.dark ? 'black' : 'primary'" >
              <div class="d-flex align-center" style="flex: 1 1 auto; min-width: 0;">
                <v-icon color="white" medium class="mr-2">stacked_bar_chart</v-icon>
                <span class="white--text body-font body-1 font-weight-bold text-uppercase text-ellipsis">{{ pointsVsXPointsChart.title }}</span>
              </div>
              <v-menu offset-y style="flex-shrink: 0;">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    icon
                    class="white--text"
                  >
                    <v-icon color="white">more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="saveAs('png', 'pointsVsXPointsChart', pointsVsXPointsChart.title)">
                    <v-list-item-title>PNG</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="saveAs('svg', 'pointsVsXPointsChart', pointsVsXPointsChart.title)">
                    <v-list-item-title>SVG</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-title>
            <div class="d-flex justify-space-between align-center px-4" style="padding-top: 0px !important; padding-bottom: 0px !important;">
              <div class="d-flex align-center">
                <img
                  :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${teamId ? teamId : currentUser.team.teamId}.png`"
                  width="18"
                  class="mr-1"
                  v-if="currentUser.team || teamId"
                />
                <span class="subheader-font body-2">
                  {{teamName ? teamName : (currentUser.team ? currentUser.team.teamName : currentUser.clientName)}}
                </span>
              </div>
              <v-autocomplete
                v-model="lastGamesxPointsvsPointsChartModel"
                :items="lastGames"
                item-text="name"
                item-value="id"
                menu-props="auto"
                hide-details
                dense
                class="body-2"
                style="max-width: 200px;"
                @change="updateDataAndRenderLineChart(pointsVsXPointsChart, teamStatsDataAllGames, lastGamesxPointsvsPointsChartModel, isNeededToAccumulateStats)"
              ></v-autocomplete>
            </div>
          </template>
          <LineChart
            id="pointsVsXPointsChart"
            :datasets="pointsVsXPointsChart.data.datasets"
            :xAxisLabels="pointsVsXPointsChart.data.labels"
            :gamesName="pointsVsXPointsChart.data.gamesName"
            :options="pointsVsXPointsChart.options"
          />
          <div class="ml-3 pb-3 primary--text subheader-font">
            <v-icon color="secondary" small>alarm</v-icon>
            {{ pointsVsXPointsChart.textFooter }}
          </div>
        </v-card>

        <!-- playerReportsChart -->
        <v-card
          min-height="350"
          class="card-chart"
          elevation="0" outlined
          v-if="slide === 'playerReportsChart'"
          :dark="$vuetify.theme.dark"
        >
          <template>
            <v-card-title class="py-1 white--text d-flex align-center" :class="$vuetify.theme.dark ? 'black' : 'primary'" >
              <v-icon color="white" medium class="mr-2">stacked_bar_chart</v-icon>
              <span class="white--text body-font body-1 font-weight-bold text-uppercase">{{ playerReportsChart.title }}</span>
            </v-card-title>
            <div class="d-flex justify-space-between align-center px-4" style="padding-top: 0px !important; padding-bottom: 0px !important;">
              <div class="d-flex align-center">
                <img
                  :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${teamId ? teamId : currentUser.team.teamId}.png`"
                  width="18"
                  class="mr-1"
                  v-if="currentUser.team || teamId"
                />
                <span class="subheader-font body-2">
                  {{teamName ? teamName : (currentUser.team ? currentUser.team.teamName : currentUser.clientName)}}
                </span>
              </div>
              <v-autocomplete
                v-model="reportTypesModel"
                :items="reportTypes"
                item-text="name"
                item-value="id"
                menu-props="auto"
                hide-details
                dense
                class="body-2"
                style="max-width: 200px;"
                @change="updateDataAndRenderPlayersReportChartData()"
              ></v-autocomplete>
            </div>
          </template>
          <BarChart
            id="playerReportsChart"
            :datasets="playerReportsChart.data.datasets"
            :xAxisLabels="playerReportsChart.data.labels"
            :options="playerReportsChart.options"
          ></BarChart>
          <div class="ml-3 pb-3 primary--text subheader-font">
            <v-icon color="primary" small>bar_chart</v-icon>
            {{ playerReportsChart.textFooter }}
          </div>
        </v-card>

        <!-- playerScoutChart - Last Scouting Analysis V2 -->
        <v-card
          min-height="350"
          class="card-chart"
          elevation="0"
          outlined
          v-if="slide === 'playerScoutChart'"
          :dark="$vuetify.theme.dark"
        >
          <template>
            <!-- Dark header bar (title only) -->
            <v-card-title
              class="py-1 white--text d-flex align-center"
              :class="$vuetify.theme.dark ? 'black' : 'primary'"
              style="flex-wrap: nowrap;"
            >
              <v-icon color="white" medium class="mr-2">stacked_bar_chart</v-icon>
              <span class="white--text body-font body-1 font-weight-bold text-uppercase">
                {{ playerScoutChart.title }}
              </span>
            </v-card-title>
          </template>

          <!-- Filters row below header -->
          <div class="d-flex justify-space-between align-center px-4 pt-2 pb-1">
            <div class="d-flex align-center flex-wrap">
              <span class="body-2 mr-2 d-none d-sm-inline-flex">
                {{ $t('charts.showLeaguesWithAtLeast') }}
              </span>
              <v-text-field
                v-model.number="minPlayersForLeague"
                type="number"
                dense
                hide-details
                class="mr-2"
                style="max-width: 70px;"
                @change="updateDataAndRenderPlayersScoutedChartData()"
              ></v-text-field>
              <span class="body-2 mr-4 d-none d-sm-inline-flex">
                {{ $t('charts.playersScoutedSuffix') }}
              </span>
            </div>
            <div class="d-flex align-center" style="flex-shrink: 0;">
              <v-autocomplete
                v-model="scoutTypesModel"
                :items="reportTypes"
                item-text="name"
                item-value="id"
                menu-props="auto"
                hide-details
                dense
                class="body-2"
                style="max-width: 200px;"
                @change="updateDataAndRenderPlayersScoutedChartData()"
              ></v-autocomplete>
            </div>
          </div>

          <BarChart
            id="playerScoutChart"
            :datasets="playerScoutChart.data.datasets"
            :xAxisLabels="playerScoutChart.data.labels"
            :options="playerScoutChart.options"
            :crest-urls="playerScoutChart.crests"
          ></BarChart>
          <div class="ml-3 pb-3 primary--text subheader-font d-flex align-center">
            <v-icon color="primary" small class="mr-1">alarm</v-icon>
            {{ playerScoutChart.textFooter }}
          </div>
        </v-card>
      </v-carousel-item>
    </v-carousel>
    <ChartExportLinksModal ref="chartExportLinksModalRef" :title="teamName"
    :subtitle="embedSubtitle"></ChartExportLinksModal>
  </div>
</template>
<script>
import Chart from "chart.js";
import LineChart from "@/views/charts/LineChart";
import BarChart from "@/views/charts/BarChart";
import ChartExportLinksModal from "@/views/base/ChartExportLinksModal";
import * as chartConfigs from "@/views/charts/config";
import ChartsService from "../../../services/charts.service";
import LeagueService from "../../../services/league.service";
import UserChartService from '../../../services/user-chart.service';
import UserService from '../../../services/user.service';
import DocumentService from '../../../services/document.service';
import { userHasRole,getMonthOfDate } from "../../../utils/functions";
import ResizeObserver from 'resize-observer-polyfill';
import { downloadPng, copyAndAppendElement, exportSvg } from '../../../utils/exportToPNG';
import * as d3v4 from "d3v4";
import { v4 } from 'uuid';
const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8081';

const API_URL = NODE_ENV === 'production' ? 'https://pro.driblab.com/embed-chart/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/embed-chart/'

export default {
  name: "ChartsWidget",
  components: {
    LineChart,
    BarChart,
    ChartExportLinksModal
  },
  filters: {
    getMonthOfDate(date, language) {
      return getMonthOfDate(date, language);
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  props:{
    slides:{
      type: Array,
      default: ['npgVsXGChart','xGAgainstvsNPGAgainstChart','pointsVsXPointsChart','xGvsxGAgainstChart','playerReportsChart','playerScoutChart']
    },
    teamId:{
      type:Number,
      required: false
    },
    teamName:{
      type:String,
      required: false
    },
    lastSeasonId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      cycle: true,
      numberOfGamesToActivateCurrentSeasonItem: 5,
      positions: ['Goalkeepper','Defender','Fullback','Wingback','Midfielder','Winger','Forward'],
      teamStatsDataAllGames: [],
      requestedReports: [],
      //This value is updated in loadAllDataCharts method
      currentSeasonId: 813658,
      textFooter: this.$t("charts.lastNgamesSelectText", {x: 20}), 
      lastGames: [
        { id: 10, name: this.$t("charts.lastNgamesSelectText", {x: 10}) },
        { id: 20, name: this.$t("charts.lastNgamesSelectText", {x: 20}) },
        {
          id: 0,
          name: this.$t("charts.currentSeasonSelectText")
        },
        { id: 1, name: this.$t("charts.lastAndCurrentSeasonSelectText") },
        {
          id: -1,
          name: this.$t("charts.lastSeasonSelectText"),
        },
      ],
      lastGamesxGvsNPGChartModel: 10,
      lastGamesxGAgainstvsNPGAgainstChartModel: 10,
      lastGamesxGvsxGAgainstChartModel: 10,
      lastGamesxPointsvsPointsChartModel: 10,
      reportTypes: [
        { id: 0, name: this.$t("charts.perPositions") },
        { id: 1, name: this.$t("charts.perLeagues") },
        { id: 2, name: this.$t("charts.perMonths") }
      ],
      reportTypesModel: 2,
      scoutTypesModel: 1,
      isNeededToAccumulateStats: true,
      chartKey: 0,
      embedSubtitle: '',
      minPlayersForLeague: 15,
      npgVsXGChart: {
        title: this.$t("charts.npgVsXGTitle"),
        textFooter: this.textFooter,
        data: {
          labels: [],
          gamesName: [],
          datasets: [
            {
              label: this.$t("charts.totalNPGLabel"),
              fill: 1,
              borderColor: chartConfigs.lineChartOptions.colors.success,
              borderWidth: 2,
              pointBackgroundColor:
                chartConfigs.lineChartOptions.colors.success,
              pointHoverBackgroundColor:
                chartConfigs.lineChartOptions.colors.success,
              pointBorderWidth: 2,
              pointHoverRadius: 3,
              pointHitRadius: 14,
              pointHoverBorderWidth: 3,
              pointRadius: 2,
              data: []
            },
            {
              label: this.$t("charts.totalXGLabel"),
              //Set lineTension to 0 to print dataset as Rect Line.
              lineTension: 0,
              fill: "-1",
              borderColor: chartConfigs.lineChartOptions.colors.error,
              borderWidth: 2,
              pointBackgroundColor: chartConfigs.lineChartOptions.colors.error,
              pointHoverBackgroundColor:
                chartConfigs.lineChartOptions.colors.error,
              pointBorderWidth: 2,
              pointHoverRadius: 3,
              pointHitRadius: 14,
              pointHoverBorderWidth: 3,
              pointRadius: 2,
              data: []
            }
          ]
        },
        options: chartConfigs.lineChartOptions
      },
      xGAgainstvsNPGAgainstChart: {
        title: this.$t("charts.xGAgainstvsNPGAgainstTitle"),
        textFooter: this.textFooter,
        data: {
          labels: [],
          gamesName: [],
          datasets: [
            {
              label: this.$t("charts.totalXGAgainstLabel"),
              fill: 1,
              borderColor: chartConfigs.lineChartOptions.colors.success,
              borderWidth: 2,
              pointBackgroundColor:
                chartConfigs.lineChartOptions.colors.success,
              pointHoverBackgroundColor:
                chartConfigs.lineChartOptions.colors.success,
              pointBorderWidth: 2,
              pointHoverRadius: 3,
              pointHitRadius: 14,
              pointHoverBorderWidth: 3,
              pointRadius: 2,
              data: []
            },
            {
              label: this.$t("charts.totalNPGAgainstLabel"),
              //Set lineTension to 0 to print dataset as Rect Line.
              lineTension: 0,
              fill: "-1",
              borderColor: chartConfigs.lineChartOptions.colors.error,
              borderWidth: 2,
              pointBackgroundColor: chartConfigs.lineChartOptions.colors.error,
              pointHoverBackgroundColor:
                chartConfigs.lineChartOptions.colors.error,
              pointBorderWidth: 2,
              pointHoverRadius: 3,
              pointHitRadius: 14,
              pointHoverBorderWidth: 3,
              pointRadius: 2,
              data: []
            }
          ]
        },
        options: chartConfigs.lineChartOptions
      },
      xGvsxGAgainstChart: {
        title: this.$t("charts.xGvsxGAgainstTitle"),
        textFooter: this.textFooter,
        data: {
          labels: [],
          gamesName: [],
          datasets: [
            {
              label: this.$t("charts.xGLabel"),
              fill: 1,
              borderColor: chartConfigs.lineChartOptions.colors.success,
              borderWidth: 3,
              pointBackgroundColor:
                chartConfigs.lineChartOptions.colors.success,
              pointHoverBackgroundColor:
                chartConfigs.lineChartOptions.colors.success,
              pointBorderWidth: 2,
              pointHoverRadius: 3,
              pointHitRadius: 14,
              pointHoverBorderWidth: 3,
              pointRadius: 2,
              data: []
            },
            {
              label: this.$t("charts.xGAgainstLabel"),
              fill: "-1",
              borderColor: chartConfigs.lineChartOptions.colors.error,
              borderWidth: 3,
              pointBackgroundColor: chartConfigs.lineChartOptions.colors.error,
              pointHoverBackgroundColor:
                chartConfigs.lineChartOptions.colors.error,
              pointBorderWidth: 2,
              pointHoverRadius: 3,
              pointHitRadius: 14,
              pointHoverBorderWidth: 3,
              pointRadius: 2,
              data: []
            }
          ]
        },
        options: chartConfigs.lineChartOptions
      },
      pointsVsXPointsChart: {
        title: this.$t("charts.pointsVsXPointsTitle"),
        textFooter: this.textFooter,
        data: {
          labels: [],
          gamesName: [],
          datasets: [
            {
              label: this.$t("charts.totalPoints"),
              fill: 1,
              borderColor: chartConfigs.lineChartOptions.colors.success,
              borderWidth: 2,
              pointBackgroundColor: chartConfigs.lineChartOptions.colors.success,
              pointHoverBackgroundColor: chartConfigs.lineChartOptions.colors.success,
              pointBorderWidth: 2,
              pointHoverRadius: 3,
              pointHitRadius: 14,
              pointHoverBorderWidth: 3,
              pointRadius: 2,
              data: []
            },
            {
              label: this.$t("charts.totalXPoints"),
              //Set lineTension to 0 to print dataset as Rect Line.
              lineTension: 0,
              fill: "-1",
              borderColor: chartConfigs.lineChartOptions.colors.error,
              borderWidth: 2,
              pointBackgroundColor: chartConfigs.lineChartOptions.colors.error,
              pointHoverBackgroundColor: chartConfigs.lineChartOptions.colors.error,
              pointBorderWidth: 2,
              pointHoverRadius: 3,
              pointHitRadius: 14,
              pointHoverBorderWidth: 3,
              pointRadius: 2,
              data: []
            }
          ]
        },
        options: chartConfigs.lineChartOptions
      },
      playerReportsChart: {
        title: this.$t("charts.requestedReports"),
        textFooter: this.$t("charts.perMonths"),
        data: {
          labels: [],
          datasets: [
            {
              label: this.$t("charts.requestedReports"),
              fill: true,
              borderColor: "#111827",
              backgroundColor: "#111827",
              borderWidth: 0,
              borderDash: [],
              borderDashOffset: 0.0,
              data: []
            }
          ]
        },
        options: chartConfigs.barChartOptions
      },
      playerScoutChart: {
        title: this.$t("charts.playersScouted"),
        textFooter: this.$t("charts.perMonths"),
        data: {
          labels: [],
          datasets: [
            {
              label: this.$t("charts.playersScouted"),
              fill: true,
              borderColor: "#111827",
              backgroundColor: "#111827",
              borderWidth: 0,
              borderDash: [],
              borderDashOffset: 0.0,
              data: []
            }
          ],
          crests: []
        },
        options: chartConfigs.barChartOptions
      },
      observer: null,
      chartKey: 0,
      embedSubtitle: '',
      minPlayersForLeague: 100,
      leaguesByName: {}
    }; // End return
  },
  mounted() {
    if(userHasRole(this.currentUser,"ROLE_ADMIN")){
      this.reportTypes.push(
        { id: 3, name: this.$t("charts.perClients") });
      this.reportTypesModel = 3;
      this.scoutTypesModel = 3;
    }
    this.loadAllDataCharts(this.teamId ? this.teamId : _.get(this.currentUser,'team.teamId',1));
    this.observer = new ResizeObserver(this.onResize)
    .observe(this.$el)
  },
  destroyed() {
    delete this.observer;
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserLanguage() {
      return this.$store.getters["auth/language"];
    }
  },
  methods: {
    onResize () {
      this.$emit('heightChange', this.$el.clientHeight)
    },
    async loadAllDataCharts(teamId) {
      const [teamStats, requestedReports, playersScouted, leaguesResp] = await Promise.all([
        ChartsService.getTeamStats(teamId),
        userHasRole(this.currentUser,"ROLE_ADMIN") ? ChartsService.getAllClientsRequestedReports() : ChartsService.getRequestedReports(this.currentUser.clientId,'DeepReport'),
        userHasRole(this.currentUser,"ROLE_ADMIN") ? ChartsService.getAllClientsScoutedPlayers() : ChartsService.getRequestedReports(this.currentUser.clientId,'Scouts'),
        LeagueService.getAllLeaguesByClient(this.currentUser.clientId)
      ]);

      this.teamStatsDataAllGames = teamStats;
      this.requestedReports = requestedReports;
      this.playersScouted = playersScouted;

      // Build a map from league name/label to id for crests
      // Build a map from league name/label (and normalized variants) to id for crests
      this.leaguesByName = {};
      const normalize = name =>
        name
          ? name
              .toString()
              .toLowerCase()
              .replace(/\s+/g, ' ')
              .trim()
          : null;

      if (leaguesResp && leaguesResp.data) {
        leaguesResp.data.forEach(l => {
          const candidates = [l.name, l.label].filter(Boolean);
          candidates.forEach(raw => {
            this.leaguesByName[raw] = l.id;
            const norm = normalize(raw);
            if (norm) {
              this.leaguesByName[norm] = l.id;
            }
          });
        });
      }
      //Get last season Id (current season Id).
      this.currentSeasonId = this.teamStatsDataAllGames.data[0].lastSeasonId;

      //If current Season has more than 5 games, then, enable "current season item". By default numberOfGamesToActivateCurrentSeasonItem = 5;
      if (
        this.teamStatsDataAllGames.data.filter(
          stat => stat.seasonId === this.currentSeasonId
        ).length <= this.numberOfGamesToActivateCurrentSeasonItem
      ) {
        let currentSeasonOptionIndex = _.findIndex(this.lastGames,(lg) => lg.id === 0);
        this.lastGames[currentSeasonOptionIndex].disabled = true;
      }

      this.renderLineChart(
        this.npgVsXGChart,
        this.lastGamesxGvsNPGChartModel,
        this.isNeededToAccumulateStats
      );
      this.renderLineChart(
        this.xGAgainstvsNPGAgainstChart,
        this.lastGamesxGAgainstvsNPGAgainstChartModel,
        this.isNeededToAccumulateStats
      );
      this.renderLineChart(
        this.xGvsxGAgainstChart,
        this.lastGamesxGvsxGAgainstChartModel,
        !this.isNeededToAccumulateStats
      );
      this.renderLineChart(
        this.pointsVsXPointsChart,
        this.lastGamesxPointsvsPointsChartModel,
        this.isNeededToAccumulateStats
      );
      this.renderBarChartData();
    },
    renderLineChart(chart, lastGamesModel, isTotal) {
      this.updateDataAndRenderLineChart(
        chart,
        this.teamStatsDataAllGames,
        lastGamesModel,
        isTotal
      );
    },
    renderBarChartData() {

      // PRE ORDERING _ INI _ REQUESTED REPORTS
      this.requestedReports.data.reports[0] = _.chain(this.requestedReports.data.reports[0]).map(e => {
        let position = e.xAxisLabel;
        let positionOrder = _.indexOf(this.positions,position);
        e.positionOrder = positionOrder;
        return e;
      }).orderBy(['positionOrder'],['asc']).value()
      this.requestedReports.data.reports[1] = _.chain(this.requestedReports.data.reports[1]).orderBy(['numberOfReports'],['desc']).value();
      // PRE ORDERING _ FIN _ REQUESTED REPORTS
      this.updateDataAndRenderPlayersReportChartData();
      //
      // PRE ORDERING _ INI _ SCOUTED PLAYERS
      this.playersScouted.data.reports[0] = _.chain(this.playersScouted.data.reports[0]).map(e => {
        let position = e.xAxisLabel;
        let positionOrder = _.indexOf(this.positions,position);
        e.positionOrder = positionOrder;
        return e;
      }).orderBy(['positionOrder'],['asc']).value()
      this.playersScouted.data.reports[1] = _.chain(this.playersScouted.data.reports[1]).orderBy(['numberOfReports'],['desc']).value();
      // PRE ORDERING _ FIN _ SCOUTED PLAYERS
      this.updateDataAndRenderPlayersScoutedChartData();
    },
    updateDataAndRenderLineChart(
      chart,
      teamStatsDataAllGames,
      lastGamesModel,
      isTotal
    ) {
      //If numberLastGames of this chart equals to 0, means get Current Season
      let teamStatsData;
      if(lastGamesModel === -1){
        teamStatsData = teamStatsDataAllGames.data.filter(
              stat => stat.seasonId === this.lastSeasonId
            )
      }else if(lastGamesModel === 0) {
        teamStatsData = teamStatsDataAllGames.data.filter(
              stat => stat.seasonId === this.currentSeasonId
            )
      } else if(lastGamesModel === 1){
        teamStatsData = teamStatsDataAllGames.data.filter(
                stat => stat.seasonId === this.currentSeasonId || stat.seasonId === this.lastSeasonId
              )
      }else {
        teamStatsData = teamStatsDataAllGames.data.slice(0, lastGamesModel);
      }


      //Reverse list to show first last matches
      teamStatsData.reverse();
      //Get X Axis labels
      chart.data.labels = teamStatsData.map(stat => {
        let labelName = stat.gameHomeTeamAlias === stat.teamAlias ? "vs " + stat.gameAwayTeamAlias : "@ " + stat.gameHomeTeamAlias;
        return labelName + " " + stat.gameDate
      } );
      //Get gamesName to set in tooltip
      chart.data.gamesName = teamStatsData.map(stat => stat.gameName);

      //If isTotal, means is necessary to accumulate data of each game
      if (isTotal) {
        _.reduce(
          teamStatsData,
          (accum, stat) => {
            //npgVsXGChart
            accum.xGAccum += stat.xG;
            accum.npgAccum += stat.nonPenaltyGoals;
            stat.xGAccum = accum.xGAccum;
            stat.npgAccum = accum.npgAccum;
            //xGAgainstvsNPGAgainstChart
            accum.xGAgainstAccum += stat.xGAgainst;
            accum.npgAgainstAccum += stat.nonPenaltyGoalsAgainst;
            stat.xGAgainstAccum = accum.xGAgainstAccum;
            stat.npgAgainstAccum = accum.npgAgainstAccum;
            //pointsVsXPointsChart
            accum.xPointsAccum += stat.expectedPoints;
            accum.pointsAccum += stat.points;
            stat.xPointsAccum = accum.xPointsAccum;
            stat.pointsAccum = accum.pointsAccum;

            return accum;
          },
          {
            xGAccum: 0,
            npgAccum: 0,
            xGAgainstAccum: 0,
            npgAgainstAccum: 0,
            xPointsAccum: 0,
            pointsAccum: 0
          }
        );
      }

      //Update footer text
      chart.textFooter = this.lastGames.find(
        item => item.id === lastGamesModel
      ).name;

      switch (chart.title) {
        case this.$t("charts.npgVsXGTitle"):
          //Update data Charts
          chart.data.datasets[0].data = teamStatsData.map(stat =>
            stat.npgAccum.toFixed(2)
          );
          chart.data.datasets[1].data = teamStatsData.map(stat =>
            stat.xGAccum.toFixed(2)
          );
          break;
        case this.$t("charts.xGAgainstvsNPGAgainstTitle"):
          //Update data Charts
          chart.data.datasets[0].data = teamStatsData.map(stat =>
            stat.xGAgainstAccum.toFixed(2)
          );
          chart.data.datasets[1].data = teamStatsData.map(stat =>
            stat.npgAgainstAccum.toFixed(2)
          );
          break;
        case this.$t("charts.xGvsxGAgainstTitle"):
          //Update data Charts
          chart.data.datasets[0].data = teamStatsData.map(stat =>
            Number(stat.xG.toFixed(2))
          );
          chart.data.datasets[1].data = teamStatsData.map(stat =>
            Number(stat.xGAgainst.toFixed(2))
          );
          break;
        case this.$t("charts.pointsVsXPointsTitle"):
          //Update data Charts
          chart.data.datasets[0].data = teamStatsData.map(stat =>
            stat.pointsAccum.toFixed(2)
          );
          chart.data.datasets[1].data = teamStatsData.map(stat =>
            stat.xPointsAccum.toFixed(2)
          );
          break;
        default:
          break;
      }
    },
    updateDataAndRenderPlayersReportChartData() {
      //Update footer text
      this.playerReportsChart.textFooter = this.reportTypes.find(
        item => item.id === this.reportTypesModel
      ).name;
      //Get X Axis labels
      const reportsSource = this.requestedReports.data.reports[this.reportTypesModel] || [];
      const orderedReports = this.reportTypesModel === 1
        ? _.orderBy(reportsSource, ['numberOfReports'], ['desc'])
        : reportsSource;

      this.playerReportsChart.data.labels = orderedReports.map(stat =>
        this.reportTypesModel === 2
          ? getMonthOfDate(stat.reportMonth, this.currentUserLanguage)
          : stat.xAxisLabel
      );

      this.playerReportsChart.data.datasets[0].data = orderedReports.map(stat => stat.numberOfReports);
    },
    updateDataAndRenderPlayersScoutedChartData() {
      //Update footer text
      this.playerScoutChart.textFooter = this.reportTypes.find(
        item => item.id === this.scoutTypesModel
      ).name;

      const reportsSource = this.playersScouted.data.reports[this.scoutTypesModel] || [];

      // Filter by minimum players per league (only for per-league view)
      const filteredReports = this.scoutTypesModel === 1
        ? reportsSource.filter(stat => stat.numberOfReports >= this.minPlayersForLeague)
        : reportsSource;

      // Order by number of players (descending) for cleaner layout
      const orderedReports = _.orderBy(filteredReports, ['numberOfReports'], ['desc']);

      //Get X Axis labels
      this.playerScoutChart.data.labels = orderedReports.map(stat =>
        this.scoutTypesModel === 2
          ? getMonthOfDate(stat.reportMonth, this.currentUserLanguage)
          : stat.xAxisLabel
      );
      //Update data Charts
      this.playerScoutChart.data.datasets[0].data = orderedReports.map(stat => stat.numberOfReports);

      // League crests for per-league view based on league name → id mapping
      this.playerScoutChart.crests = orderedReports.map(stat => {
        if (this.scoutTypesModel !== 1 || !stat.xAxisLabel) {
          return null;
        }
        const raw = stat.xAxisLabel;
        const normalized = raw
          ? raw
              .toString()
              .toLowerCase()
              .replace(/\s+/g, ' ')
              .trim()
          : null;
        const leagueId =
          this.leaguesByName[raw] ||
          (normalized ? this.leaguesByName[normalized] : null);
        return leagueId
          ? `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${leagueId}.png`
          : null;
      });
    },
    async saveAs(mode, elementId, title) {
      let svg = await this.getElementToExport(elementId);
      if(mode === 'png'){
        downloadPng(svg, title.replace(" ", "_") + "_" + this.teamName.replace(" ", "_") + ".png");
      }else{
        exportSvg(svg, title + " - " + this.teamName);
      }

    },
    async getElementToExport(elementId){
      let svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
      var chart = document.querySelector(`#${elementId}`);
      var imgData = chart.toDataURL("image/png");

      d3.select(svg)
        .append('image', imgData)
        .attr("href", imgData)
        .attr("width", chart.getBoundingClientRect().width);

      svg.setAttribute("width", chart.getBoundingClientRect().width);
      svg.setAttribute("height", chart.getBoundingClientRect().height);

      return svg;
    },
    //Not working because -> TypeError: Converting circular structure to JSON
    //There is a circular structure on chart.data.datasets and can't Stringify the object
    async onGenerateIFrameClick(chartId, title){
      this.embedSubtitle = title;
      let elToExport = await this.getElementToExport(chartId);
      let key = v4();
      key = `${key}.json`;
      let heightOffsetMediaMode = 0.94;
      let heightOffset = 1;
      let chartObject = {
        awsKey: key,
        tool: 'embed',
        category: 'team',
        componentId: this.teamId,
        width: elToExport.getAttribute("width"),
        height: elToExport.getAttribute("height") * heightOffset
      }
      let postResponse = await UserChartService.postChart(chartObject)
      let chartEntity = postResponse.data;
      let chart;

      switch (chartId) {
        case 'npgVsXGChart':
          chart = this.npgVsXGChart;
          break;
        case 'xGAgainstvsNPGAgainstChart':
          chart = this.xGAgainstvsNPGAgainstChart;
          break;
        case 'pointsVsXPointsChart':
          chart = this.pointsVsXPointsChart;
          break;
        case 'xGvsxGAgainstChart':
          chart = this.xGvsxGAgainstChart;
          break;
        default:
          break;
      }

      this.$refs.chartExportLinksModalRef.open(chartEntity);

      let urlResponse = await UserChartService.getUploadURL(chartEntity.id,key);
      let uploadUrl = urlResponse.data;
      var jsonse = JSON.stringify({
        size: Number(chartEntity.width),
        height: Number(chartEntity.height),
        teamName:this.teamName,
        language:this.currentUserLanguage,
        mediaModeData: this.mediaModeData,
        mediaMode: false,
        key: this.chartKey,
        id: chartId,
        chartType: chartId,
        datasets: chart.data.datasets,
        xAxisLabels: chart.data.labels,
        gamesName: chart.data.gamesName,
        options: chart.options
      });

      var blob = new Blob([jsonse], {type: "application/json"});

      let uploadResponse = await DocumentService.upload(uploadUrl,blob);
      this.postSearchChart(chartEntity);
    },
    async postSearchChart(chart){
      const authorized = true;
      let metaInfo = null;
      let category = "player";
      let urlId = this.playerId;

      metaInfo = JSON.stringify({
        link: `${API_URL}${chart.id}/key/${chart.awsKey}/compId/${chart.componentId}/catId/${chart.categoryId}/tId/${chart.toolId}`
      });
      const tool = 'embed';
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const browser = navigator.userAgent;
      let searchResponse = await UserService.postUserSearch(category, tool, urlId, authorized, this.$route.path, timeZone, browser, metaInfo);
      UserService.putLastSearchRendered({category,tool,id:searchResponse.data})
    },
    cycling(active){
      this.cycle = active;
    },
  }
};
</script>
<style>
.logo {
  position: absolute;
  top: 86%;
  right: 3%;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/ChartsWidget.vue